import React from "react";
import { NewFeedModel } from "../../newfeeds/models/NewFeedModel";
import {
    CollageDisplayCount, CollageLayout, PhotoSize
} from "../models/PhotoCollageModel";
import FivePhotoView from "./FivePhotoView";
import FourPhotoView from "./FourPhotoView";
import { PhotoShapeManager } from "./PhotoShapeManager";
import ThreePhotoView from "./ThreePhotoView";
import TwoPhotoView from "./TwoPhotoView";

type CollageViewProps = {
    feed: NewFeedModel;
    photoManager: PhotoShapeManager;
    onSelect?: (count: CollageDisplayCount, layout: CollageLayout) => void;
}

export default function CollageView({ feed, photoManager, onSelect }: CollageViewProps) {
    const getDisplayCount = (): CollageDisplayCount => {
        if (feed.displayCount && isvalidCount()) {
            return feed.displayCount;
        }

        const count = feed.pictures.length;

        if (count === 1) return CollageDisplayCount.one;
        else if (count === 2) return CollageDisplayCount.two;
        else if (count === 3) return CollageDisplayCount.three;
        else if (count === 4) return CollageDisplayCount.four;

        return CollageDisplayCount.five;
    }

    const isvalidCount = (): boolean => {
        if (!feed.displayCount) return false;

        let intCount = feed.displayCount as number;

        return feed.pictures.length >= intCount;
    }

    const getLayout = (count: CollageDisplayCount): CollageLayout => {
        if (feed.layout) return feed.layout;

        if (count === CollageDisplayCount.one)
            return CollageLayout.horizontalHalf;
        else if (count === CollageDisplayCount.two)
            return CollageLayout.horizontalHalf;
        else if (count === CollageDisplayCount.three)
            return CollageLayout.horizontalTwoThird;
        else if (count === CollageDisplayCount.four)
            return CollageLayout.verticalTwoThird;
        else if (count === CollageDisplayCount.five)
            return CollageLayout.verticalTwoThird;

        return CollageLayout.allSquare;
    }

    const count = getDisplayCount();
    const layout = getLayout(count);

    return <div className="p-20" style={{ minHeight: 300 }}
        onClick={() => { if (onSelect) { onSelect(count, layout) } }}>

        {count === CollageDisplayCount.one && <>
            {photoManager.getRectangle(
                feed.pictures[0],
                PhotoSize.extraFull,
                PhotoSize.extraFull,
                true
            )}
        </>}
        {count === CollageDisplayCount.two && <>
            <TwoPhotoView
                photos={feed.pictures}
                photoManager={photoManager}
                layout={layout}
            />
        </>}
        {count === CollageDisplayCount.three && <>
            <ThreePhotoView
                photos={feed.pictures}
                photoManager={photoManager}
                layout={layout}
            />
        </>}
        {count === CollageDisplayCount.four && <>
            <FourPhotoView
                photos={feed.pictures}
                photoManager={photoManager}
                layout={layout}
            />
        </>}
        {count === CollageDisplayCount.five && <>
            <FivePhotoView
                photos={feed.pictures}
                photoManager={photoManager}
                layout={layout}
            />
        </>}
    </div>;
}